import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Shield } from 'lucide-react';

export function AdminNavBadge({ user }) {
  const navigate = useNavigate();
  const location = useLocation();

  if (user?.role !== 'admin') return null;
  if (location.pathname === '/admin') return null;

  return (
    <button
      onClick={() => navigate('/admin')}
      className="fixed top-4 right-4 z-40 flex items-center gap-1.5 px-3 py-1.5 bg-[#0A0A0A]/90 border border-[#D4AF37]/30 rounded-sm text-[#D4AF37] text-xs font-semibold hover:bg-[#1A1A1A] transition-colors backdrop-blur-sm"
      data-testid="global-admin-nav"
      aria-label="Admin Dashboard"
    >
      <Shield className="w-3.5 h-3.5" />
      Admin
    </button>
  );
}
